module.exports = __webpack_public_path__ + "static/marc_n-5fc9e7acc3d6085b356c2081da55b97d.png";